<template>
    <div class="card mb-4 pointer"
        :class="{disabled: book.pickup_number}"
        @click="$emit('addPickup', book)">
        <div class="card-body">
            <h5 class="card-title">
                <i class="fas fa-check-circle" v-if="book.pickup_number"></i>
                {{book.title}}
            </h5>
            <h6 class="card-subtitle">{{book.subtitle}}</h6>
            <p class="card-text small" v-html="desc(book.description)"></p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.disabled {
    color: #999;
}
</style>

<script>
export default {
    props: {
        book: {
            required: true
        }
    },
    methods: {
        desc(d) {
            d = this.$filters.wrap(d);
            d = this.$filters.truncate(d, 80);
            return d;
        }
    },
}
</script>